// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import {
  deleteChronicMedication,
  addChronicMedication,
  updateChronicMedication,
  deleteAcuteMedication,
  addAcuteMedication,
  updateAcuteMedication,
} from '../../../actions/treatmentActions';

import DateText from '../../DateText.jsx';
import Table from '../../Table.jsx';
import Typeahead from '../../Typeahead.jsx';

type Props = {
  activePatientId: string,
  medications: Object[],
  problemId: string,
  addChronicMedication: Function,
  deleteChronicMedication: Function,
  updateChronicMedication: Function,
  addAcuteMedication: Function,
  deleteAcuteMedication: Function,
  updateAcuteMedication: Function,
  acute: boolean,
  chronic: boolean,
}

class ProblemMedicationTableComponent extends Component<Props> {
  /* eslint-disable no-param-reassign */
  transformDates(formValues) {
    formValues.startDate = moment(formValues.startDate, 'DD-MM-YYYY').toISOString();
    formValues.endDate = moment(formValues.endDate, 'DD-MM-YYYY').toISOString();
  }

  handleDeleteRow = (id: string) => {
    if (this.props.acute) {
      this.props.deleteAcuteMedication(this.props.activePatientId, id);
    } else if (this.props.chronic) {
      this.props.deleteChronicMedication(this.props.activePatientId, id);
    }
  }

  handleSaveRow = (id: string, formData: Object) => {
    this.transformDates(formData.values);
    if (this.props.acute) {
      this.props.updateAcuteMedication(this.props.activePatientId,
        {
          treatmentId: id,
          ...formData.values,
        });
    } else if (this.props.chronic) {
      this.props.updateChronicMedication(this.props.activePatientId,
        {
          treatmentId: id,
          ...formData.values,
        });
    }
  }

  handleSaveNewRow = (formData: Object) => {
    this.transformDates(formData.values);
    if (this.props.acute) {
      this.props.addAcuteMedication(this.props.activePatientId, {
        problemId: this.props.problemId,
        ...formData.values,
      });
    } else if (this.props.chronic) {
      this.props.addChronicMedication(this.props.activePatientId, {
        problemId: this.props.problemId,
        ...formData.values,
      });
    }
  }

  render() {
    const columns = [
      {
        Header: 'Start Date',
        id: 'startDate',
        cell: item => (item.startDate ? moment(item.startDate).format() : '--'),
        editCell: item => <DateText field='startDate' item={item} />,
        width: 100,
      },
      {
        Header: 'End Date',
        id: 'endDate',
        cell: item => (item.endDate ? moment(item.endDate).format() : '(ongoing)'),
        editCell: item => <DateText field="endDate" item={item} nullable />,
        width: 100,
      },
      {
        Header: 'Name of Rx',
        id: 'drugName',
        editCell: item => <Typeahead field='drugName' initialValue={item.drugName} endpoint='rxName' />,
        width: 200,
      },
      {
        Header: 'Dose',
        id: 'dose',
        editCell: item => <Typeahead field='dose' initialValue={item.dose} endpoint='dose' />,
      },
      {
        Header: 'Frequency',
        id: 'time',
        editCell: item => <Typeahead field='time' initialValue={item.time} endpoint='time' />,
      },
      {
        Header: 'Route',
        id: 'route',
        editCell: item => <Typeahead field='route' initialValue={item.route} endpoint='route' />,
      },
    ];

    let { medications } = this.props;
    medications = medications.sort((a, b) => {
      if (a.endDate && !b.endDate) {
        return 1;
      }
      if (b.endDate && !a.endDate) {
        return -1;
      }
      return 0;
    });

    return (
      <Table
        columns={columns}
        data={medications}
        handleDeleteRow={this.handleDeleteRow}
        handleSaveRow={this.handleSaveRow}
        handleSaveNewRow={this.handleSaveNewRow}
      />
    );
  }
}


const mapStateToProps = state => ({
  activePatientId: state.patient.data.activePatientId,
});

const mapDispatchToProps = dispatch => ({
  addChronicMedication:
    (patientId, medication) => dispatch(addChronicMedication(patientId, medication)),
  deleteChronicMedication:
    (patientId, medicationId) => dispatch(deleteChronicMedication(patientId, medicationId)),
  updateChronicMedication:
    (patientId, medication) => dispatch(updateChronicMedication(patientId, medication)),
  addAcuteMedication:
    (patientId, medication) => dispatch(addAcuteMedication(patientId, medication)),
  deleteAcuteMedication:
    (patientId, medicationId) => dispatch(deleteAcuteMedication(patientId, medicationId)),
  updateAcuteMedication:
    (patientId, medication) => dispatch(updateAcuteMedication(patientId, medication)),
});

const ProblemMedicationTable = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProblemMedicationTableComponent);

export default ProblemMedicationTable;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/progressNote/ProblemMedicationTable.jsx